// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDependentInfoDto } from './IDependentInfoDto';
import {
    IDependentInfoDtoFromJSON,
    IDependentInfoDtoFromJSONTyped,
    IDependentInfoDtoToJSON,
    IDependentInfoDtoToJSONTyped,
} from './IDependentInfoDto';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IUserCommunicationConfigurationInfoDto } from './IUserCommunicationConfigurationInfoDto';
import {
    IUserCommunicationConfigurationInfoDtoFromJSON,
    IUserCommunicationConfigurationInfoDtoFromJSONTyped,
    IUserCommunicationConfigurationInfoDtoToJSON,
    IUserCommunicationConfigurationInfoDtoToJSONTyped,
} from './IUserCommunicationConfigurationInfoDto';
import type { IEmployeeOrganizationInfoDto } from './IEmployeeOrganizationInfoDto';
import {
    IEmployeeOrganizationInfoDtoFromJSON,
    IEmployeeOrganizationInfoDtoFromJSONTyped,
    IEmployeeOrganizationInfoDtoToJSON,
    IEmployeeOrganizationInfoDtoToJSONTyped,
} from './IEmployeeOrganizationInfoDto';
import type { IPersonAddressInfoDto } from './IPersonAddressInfoDto';
import {
    IPersonAddressInfoDtoFromJSON,
    IPersonAddressInfoDtoFromJSONTyped,
    IPersonAddressInfoDtoToJSON,
    IPersonAddressInfoDtoToJSONTyped,
} from './IPersonAddressInfoDto';

/**
 * 
 * @export
 * @interface IEmployeePersonalInfoDto
 */
export interface IEmployeePersonalInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeePersonalInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEmployeePersonalInfoDto
     */
    person_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeePersonalInfoDto
     */
    hire_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    gender_type?: IEmployeePersonalInfoDtoGenderTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeePersonalInfoDto
     * @deprecated
     */
    birth_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeePersonalInfoDto
     */
    local_date_birth_on?: Date;
    /**
     * 
     * @type {Set<IDependentInfoDto>}
     * @memberof IEmployeePersonalInfoDto
     */
    dependents?: Set<IDependentInfoDto>;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    employer_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeePersonalInfoDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {IPersonAddressInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    preferred_address?: IPersonAddressInfoDto;
    /**
     * 
     * @type {IPersonAddressInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    mailing_address?: IPersonAddressInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    home_phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    mobile_phone_number?: string;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    phone1?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    phone2?: IPhoneInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    status?: IEmployeePersonalInfoDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeePersonalInfoDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    user_name?: string;
    /**
     * 
     * @type {IEmployeeOrganizationInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    organization?: IEmployeeOrganizationInfoDto;
    /**
     * 
     * @type {IUserCommunicationConfigurationInfoDto}
     * @memberof IEmployeePersonalInfoDto
     */
    user_communication_configuration?: IUserCommunicationConfigurationInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    claim_autopay_type?: IEmployeePersonalInfoDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    default_claim_payee_type?: IEmployeePersonalInfoDtoDefaultClaimPayeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    payroll_group_code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeePersonalInfoDto
     */
    is_organization_locked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IEmployeePersonalInfoDto
     */
    unique_ee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    custom_field1?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    custom_field2?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    custom_field3?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    custom_field4?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePersonalInfoDto
     */
    custom_field5?: string;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeePersonalInfoDtoGenderTypeEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeePersonalInfoDtoStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeePersonalInfoDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeePersonalInfoDtoDefaultClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}


/**
 * Check if a given object implements the IEmployeePersonalInfoDto interface.
 */
export function instanceOfIEmployeePersonalInfoDto(value: object): value is IEmployeePersonalInfoDto {
    return true;
}

export function IEmployeePersonalInfoDtoFromJSON(json: any): IEmployeePersonalInfoDto {
    return IEmployeePersonalInfoDtoFromJSONTyped(json, false);
}

export function IEmployeePersonalInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeePersonalInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'hire_on': json['hire_on'] == null ? undefined : (new Date(json['hire_on'])),
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'gender_type': json['gender_type'] == null ? undefined : json['gender_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'local_date_birth_on': json['local_date_birth_on'] == null ? undefined : (new Date(json['local_date_birth_on'])),
        'dependents': json['dependents'] == null ? undefined : (new Set((json['dependents'] as Array<any>).map(IDependentInfoDtoFromJSON))),
        'employer_provided_email': json['employer_provided_email'] == null ? undefined : json['employer_provided_email'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'preferred_address': json['preferred_address'] == null ? undefined : IPersonAddressInfoDtoFromJSON(json['preferred_address']),
        'mailing_address': json['mailing_address'] == null ? undefined : IPersonAddressInfoDtoFromJSON(json['mailing_address']),
        'home_phone_number': json['home_phone_number'] == null ? undefined : json['home_phone_number'],
        'mobile_phone_number': json['mobile_phone_number'] == null ? undefined : json['mobile_phone_number'],
        'phone1': json['phone1'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone1']),
        'phone2': json['phone2'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone2']),
        'status': json['status'] == null ? undefined : json['status'],
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'organization': json['organization'] == null ? undefined : IEmployeeOrganizationInfoDtoFromJSON(json['organization']),
        'user_communication_configuration': json['user_communication_configuration'] == null ? undefined : IUserCommunicationConfigurationInfoDtoFromJSON(json['user_communication_configuration']),
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'default_claim_payee_type': json['default_claim_payee_type'] == null ? undefined : json['default_claim_payee_type'],
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
        'is_organization_locked': json['is_organization_locked'] == null ? undefined : json['is_organization_locked'],
        'unique_ee_id': json['unique_ee_id'] == null ? undefined : json['unique_ee_id'],
        'custom_field1': json['custom_field1'] == null ? undefined : json['custom_field1'],
        'custom_field2': json['custom_field2'] == null ? undefined : json['custom_field2'],
        'custom_field3': json['custom_field3'] == null ? undefined : json['custom_field3'],
        'custom_field4': json['custom_field4'] == null ? undefined : json['custom_field4'],
        'custom_field5': json['custom_field5'] == null ? undefined : json['custom_field5'],
    };
}

export function IEmployeePersonalInfoDtoToJSON(json: any): IEmployeePersonalInfoDto {
    return IEmployeePersonalInfoDtoToJSONTyped(json, false);
}

export function IEmployeePersonalInfoDtoToJSONTyped(value?: IEmployeePersonalInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'person_id': value['person_id'],
        'hire_on': value['hire_on'] == null ? undefined : ((value['hire_on']).toISOString()),
        'full_name': value['full_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'middle_name': value['middle_name'],
        'suffix': value['suffix'],
        'ssn': value['ssn'],
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'gender_type': value['gender_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString()),
        'local_date_birth_on': value['local_date_birth_on'] == null ? undefined : ((value['local_date_birth_on']).toISOString().substring(0,10)),
        'dependents': value['dependents'] == null ? undefined : (Array.from(value['dependents'] as Set<any>).map(IDependentInfoDtoToJSON)),
        'employer_provided_email': value['employer_provided_email'],
        'employee_provided_email': value['employee_provided_email'],
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'preferred_address': IPersonAddressInfoDtoToJSON(value['preferred_address']),
        'mailing_address': IPersonAddressInfoDtoToJSON(value['mailing_address']),
        'home_phone_number': value['home_phone_number'],
        'mobile_phone_number': value['mobile_phone_number'],
        'phone1': IPhoneInfoDtoToJSON(value['phone1']),
        'phone2': IPhoneInfoDtoToJSON(value['phone2']),
        'status': value['status'],
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'user_name': value['user_name'],
        'organization': IEmployeeOrganizationInfoDtoToJSON(value['organization']),
        'user_communication_configuration': IUserCommunicationConfigurationInfoDtoToJSON(value['user_communication_configuration']),
        'claim_autopay_type': value['claim_autopay_type'],
        'default_claim_payee_type': value['default_claim_payee_type'],
        'payroll_group_code': value['payroll_group_code'],
        'is_organization_locked': value['is_organization_locked'],
        'unique_ee_id': value['unique_ee_id'],
        'custom_field1': value['custom_field1'],
        'custom_field2': value['custom_field2'],
        'custom_field3': value['custom_field3'],
        'custom_field4': value['custom_field4'],
        'custom_field5': value['custom_field5'],
    };
}

